import type { Booking, ParsedSegment, SortConfig } from '../lib/types'

export function sortBookings(bookings: Booking[], sortConfig: SortConfig): Booking[] {
  if (!sortConfig.column || !sortConfig.direction) return bookings

  return [...bookings].sort((a, b) => {
    let aVal: string | number | null = null
    let bVal: string | number | null = null

    switch (sortConfig.column) {
      case 'user':
        aVal = a.user_name || ''
        bVal = b.user_name || ''
        break
      case 'airline':
        aVal = a.airline_code || ''
        bVal = b.airline_code || ''
        break
      case 'route':
        const aSegs = a.segments || []
        const bSegs = b.segments || []
        aVal = aSegs[0]?.origin || ''
        bVal = bSegs[0]?.origin || ''
        break
      case 'pnr':
        aVal = a.pnr || ''
        bVal = b.pnr || ''
        break
      case 'paid':
        aVal = a.total_price_paid || 0
        bVal = b.total_price_paid || 0
        break
      case 'now':
        aVal = a.latest_price || 0
        bVal = b.latest_price || 0
        break
      case 'savings':
        aVal = a.potential_savings || 0
        bVal = b.potential_savings || 0
        break
      case 'status':
        aVal = a.is_active ? 1 : 0
        bVal = b.is_active ? 1 : 0
        break
      case 'checked':
        aVal = a.last_checked_at ? new Date(a.last_checked_at).getTime() : 0
        bVal = b.last_checked_at ? new Date(b.last_checked_at).getTime() : 0
        break
      default:
        return 0
    }

    if (aVal === null || bVal === null) return 0
    if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1
    if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1
    return 0
  })
}

export function formatRoute(segments?: ParsedSegment[]): string | null {
  if (!segments || segments.length === 0) return null
  const first = segments[0]
  const last = segments[segments.length - 1]
  if (segments.length === 1) {
    return `${first.origin} → ${first.destination}`
  }
  return `${first.origin} → ${last.destination}`
}
